import { Button } from "@/components/ui/button";
import { useState } from "react";
import { CreateStipendSheet } from "./CreateStipendSheet";
import { StipendTable } from "./StipendMangerTable";
import { useStipendRulesQuery } from "@common/utils/graphql";
import { StipendRule } from "./types";
import { useResetRecoilState, useSetRecoilState } from "recoil";
import { createOrEditStipendState } from "@common/state/createOrEditStipendState";
import { entireCompany } from "@common/components/SelectDepartment";
import { addTimezoneOffsetToUTCZeroTimeIfNeeded } from "@common/components/utils";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { FullPageLoader } from "@common/components/Loading/FullPageLoading";

export const StipendManager = () => {
  const [search, setSearch] = useState("");
  const [isCreateStipendOpen, setIsCreateStipendOpen] = useState(false);
  const resetCreateOrEditStipendState = useResetRecoilState(
    createOrEditStipendState,
  );
  const setCreateOrEditStipendState = useSetRecoilState(
    createOrEditStipendState,
  );
  const { data, loading } = useStipendRulesQuery({
    variables: {
      filters: { searchText: search.length > 0 ? search : undefined },
    },
  });

  const stipendRules =
    data?.stipendRules.__typename === "QueryStipendRulesSuccess"
      ? data.stipendRules.data.stipendRules
      : [];

  const handleCreateStipend = () => {
    setIsCreateStipendOpen(true);
  };

  const handleEditStipend = (stipendRule: StipendRule) => {
    const departments =
      stipendRule.departments && stipendRule.departments.length > 0
        ? stipendRule.departments
        : [entireCompany];
    setCreateOrEditStipendState({
      name: stipendRule.name,
      terms: stipendRule.terms ?? "",
      longDetails: stipendRule.longDetails ?? "",
      departments,
      frequency: stipendRule.frequency,
      isBalanceForwardable: stipendRule.isBalanceForwardable,
      amount: stipendRule.amount,
      startsAt: stipendRule.startsAt
        ? addTimezoneOffsetToUTCZeroTimeIfNeeded(stipendRule.startsAt)
        : undefined,
      expiresAt: stipendRule.expiresAt
        ? addTimezoneOffsetToUTCZeroTimeIfNeeded(stipendRule.expiresAt)
        : undefined,
      id: stipendRule.id,
      category: stipendRule.category,
    });
    setIsCreateStipendOpen(true);
  };

  const handleClose = () => {
    setIsCreateStipendOpen(false);
    resetCreateOrEditStipendState();
  };

  return (
    <div className="mt-6 grow">
      <div className="flex w-full gap-x-4">
        <Input
          className="grow"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search by stipend name..."
        />
        <Button onClick={handleCreateStipend}>Create Stipend</Button>
      </div>
      {loading && stipendRules.length === 0 ? (
        <FullPageLoader />
      ) : (
        <>
          {isCreateStipendOpen && <CreateStipendSheet onClose={handleClose} />}
          <Card className="mt-6">
            <StipendTable
              onEdit={handleEditStipend}
              stipendRules={stipendRules}
            />
          </Card>
        </>
      )}
    </div>
  );
};
